import { Link } from "react-router-dom";
import { PhoneCall, Mail, MapPin, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-deep text-white/85 pb-24 md:pb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-16 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-12">
          <div className="col-span-2 md:col-span-1">
            <img src="/logo-light.png" alt="SolarSoch" className="h-12 w-auto mb-5" />
            <p className="text-sm leading-relaxed text-white/60 max-w-xs">
              SolarSoch turns your rooftop into your own private power plant — engineered to
              last 25 years, backed by people who stay with you long after the last panel is installed.
            </p>
            <p className="mt-4 font-mono text-xs tracking-[0.25em] text-gold">SAHI SOCH ☀ SAHI SAVINGS</p>
          </div>

          <div>
            <h4 className="font-mono text-xs tracking-[0.3em] text-gold mb-5">EXPLORE</h4>
            <ul className="space-y-3 text-sm">
              {[
                ["Home", "/"],
                ["Our Services", "/services"],
                ["Solar Offerings", "/offerings"],
                ["Savings Calculator", "/calculator"],
                ["FAQ", "/faq"],
                ["Contact Us", "/contact"],
              ].map(([label, path]) => (
                <li key={path}>
                  <Link
                    to={path}
                    data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="group inline-flex items-center gap-1.5 text-white/70 hover:text-gold transition-colors"
                  >
                    {label}
                    <ArrowUpRight size={13} className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-xs tracking-[0.3em] text-gold mb-5">REACH US</h4>
            <ul className="space-y-4 text-sm text-white/70">
              <li className="flex gap-3">
                <PhoneCall size={16} className="text-gold shrink-0 mt-0.5" />
                <a href="tel:+919619613720" data-testid="footer-phone-link" className="hover:text-gold transition-colors">+91 96196 13720</a>
              </li>
              <li className="flex gap-3">
                <Mail size={16} className="text-gold shrink-0 mt-0.5" />
                <a href="mailto:info@solarsoch.com" data-testid="footer-email-link" className="hover:text-gold transition-colors">info@solarsoch.com</a>
              </li>
              <li className="flex gap-3">
                <MapPin size={16} className="text-gold shrink-0 mt-0.5" />
                <span>
                  Thrivasol Renewable Technologies Pvt. Ltd.<br />
                  #404D, 1st Floor, KHB Colony, 5th Block,<br />
                  Koramangala, Bengaluru – 560095
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <span>© 2026 Thrivasol Renewable Technologies Private Limited. All rights reserved.</span>
          <span className="font-mono tracking-widest">CUT BILLS. BRING SOLAR HOME.</span>
        </div>
      </div>
    </footer>
  );
}
